module.exports = __webpack_public_path__ + "static/img/smartAutomate.b968e082.png";